/**
 * Lightweight UA-based platform detection for the web app.
 *
 * UA sniffing is brittle by nature — use it only for dismissible enhancements
 * (install banners), never to gate core functionality.
 */
export type MobilePlatform = 'ios' | 'android';

function ua(): string {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

/** Returns the mobile OS, or null on desktop / SSR. */
export function getMobilePlatform(): MobilePlatform | null {
  const s = ua();
  if (/android/i.test(s)) return 'android';
  if (/iphone|ipad|ipod/i.test(s)) return 'ios';
  return null;
}

/** True on any mobile device (iOS or Android). */
export function isMobileDevice(): boolean {
  return getMobilePlatform() !== null;
}

/** Android, excluding embedded webviews (in-app browsers) where intent:// is unreliable. */
export function isAndroidDevice(): boolean {
  const s = ua();
  return /android/i.test(s) && !/\bwv\b/i.test(s);
}
